import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { StoreProfile } from "@/types/store";

export function useStore() {
  const { user } = useAuth();

  return useQuery<StoreProfile>({
    queryKey: ["store", user?.id],
    queryFn: async () => {
      if (!user?.id) throw new Error("User ID is required");

      const { data, error } = await supabase
        .from("store_profiles")
        .select("*")
        .eq("florist_id", user.id)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
    refetchOnWindowFocus: false,
  });
} 